import { Box, withStyles } from '@material-ui/core';

export const ContextBox = withStyles(({ palette, spacing }) => ({
  root: {
    padding: spacing(2),
    background: palette.common.white,
    color: palette.common.black,
    borderRadius: spacing(0.8),
  },
}))(Box);
